import React, { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { useMediaQuery } from "react-responsive"
import { nanoid } from "nanoid"

import { fbAuth } from "../../services/Firebase"
import { SearchRecipeContext } from "../../contexts/SearchRecipeContext"
import { ShowSearchContext } from "../../contexts/ShowSearchContext"
import { useFavorite } from "../../contexts/FavoriteContext"
import { HiOutlineArrowNarrowLeft, HiOutlineClock } from "react-icons/hi"
import { IoFastFoodOutline } from "react-icons/io5"
import { MdFavoriteBorder } from "react-icons/md"
import Loading from "../../components/Loading"
import SearchRecipePage from "./SearchRecipePage"
import Navbar from "../../components/navbar/Navbar"
import MobileNav from "../../components/navbar/MobileNav"
import Service from "../../services/Service"

function RecipeGallery() {
    const history = useHistory()
    const location = useLocation()
    const allowFavorite = useFavorite()
    const isMobileDevice = useMediaQuery({ query: "(max-device-width: 650px)" })
    const query = location.pathname.substr(8)
    const { allRecipes, setAllRecipes } = React.useContext(SearchRecipeContext)
    const { showPage, setShowPage } = React.useContext(ShowSearchContext)
    const [favRecipes, setFavRecipes] = useState([])
    let user = {}

    if (fbAuth.currentUser) {
        user = fbAuth.currentUser
    }
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (location.pathname.includes("/searchRecipe")) {
            setLoading(false)
        } else if (location.pathname.includes("&diet=&intolerances=")) {
            setLoading(true)
        }

        if (!location.pathname.includes("/searchRecipe")) {
            Service.handleFetchAndStoreLS( query, setAllRecipes )
        }

        const getRecipes = () => {
            const dataset = Service.getDataFromLS( "searchRecipes" )
            setAllRecipes(dataset)
            setTimeout(() => {
                setLoading(false)
            }, 2000)
        }
        getRecipes()

    }, [
        location.pathname,
        query,
        favRecipes,
        setFavRecipes,
        setAllRecipes
    ])

    const handleRouting = () => history.push("/")

    const handleRecipeRouting = (e) => {
        history.push(`/searchRecipe/${e.target.parentElement.id}`)
        displayPage()
    }

    const displayPage = () => setShowPage(!showPage)

    const handleFavorite = (e) => {
        e.target.classList.toggle("active")
        const dataset = Service.getDataFromLS( `${user.uid}-recipes` )
        const recipeId = e.target.parentElement.id
        const chosenRecipe = allRecipes.find(item => Number(item.id) === Number(recipeId))
        const noDups = [...new Set(dataset)]
        Service.storeData(`${user.uid}-recipes`, [...noDups, chosenRecipe])
        console.log("Add to Favorite")
    }

    const handleTouch = (e) => e.target.classList.add("active")

    if (loading) return <Loading />

    return (
        <article id="recipeGallery">
            {isMobileDevice ? <MobileNav setShowPage={setShowPage} /> : <Navbar setShowPage={setShowPage} />}
            {showPage
                ? <SearchRecipePage allRecipes={allRecipes} displayPage={displayPage} />
                : <>
                    <button onClick={handleRouting}><HiOutlineArrowNarrowLeft size="21px" /></button>
                    <section className="recipeTileContainer">
                        {
                            allRecipes.map(item => {
                                return <article
                                    id={item.id}
                                    className="recipeTile"
                                    key={nanoid()}>
                                    {
                                        allowFavorite
                                        && <button className="favorite" onClick={handleFavorite} onTouchStart={handleTouch}>
                                            <MdFavoriteBorder size="20px" />
                                        </button>
                                    }
                                    <img
                                        src={item.image}
                                        alt=""
                                        onClick={handleRecipeRouting}
                                    />
                                    <div>
                                        <h2>{item.title}</h2>
                                        <div className="details active">
                                            <HiOutlineClock />
                                            <span>{item.readyInMinutes} minutes</span>
                                        </div>
                                        <div className="details active">
                                            <IoFastFoodOutline />
                                            <span>{item.servings} servings</span>
                                        </div>
                                    </div>
                                </article>
                            })
                        }
                    </section>
                </>
            }
        </article>
    )
}

export default RecipeGallery
